import React, { useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const KeywordTagsSelect = ({
  formControlData: {
    handleChange,
    dataList,
    checked,
    handleCheckboxChange,
    selectedData,
    handleEconomicTagsChange,
    disabled = false,
    economicTags,
  },
  placeholder,
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTags = (term) => {
    setSearchTerm(term);
  };

  // Filter the dataList based on the search term
  const filteredDataList = dataList.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const showEconomicTags = ["economic tags"].some((keyword) =>
    keyword.includes(searchTerm.toLowerCase())
  );

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} fullWidth>
      <Select
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        value=""
        onChange={handleChange}
        displayEmpty
        disabled={disabled}
        inputProps={{ "aria-label": "Without label" }}
        IconComponent={KeyboardArrowDownIcon}
        className="map_dropdown"
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      >
        <MenuItem className="hidedata" value="">
          <em>{placeholder}</em>
          {selectedData?.length > 0 ? (
            <p>{selectedData.length} Selected</p>
          ) : (
            <p>Select</p>
          )}
        </MenuItem>

        <div className="crie_input_cont-main-mdl">
          <div className="crie_input_cont">
            <input
              type="text"
              placeholder="Type to search"
              className="crie_input"
              onChange={(e) => handleSearchTags(e.target.value)}
            />
          </div>

          {/* Show Economic Tags */}
          {showEconomicTags && (
            <div
              className={
                economicTags?.some((tag) => checked?.includes(tag))
                  ? "AI-leade-checkbox-and-data-list_2"
                  : "AI-leade-checkbox-and-data-list"
              }
            >
              <div className="checkbox-select-data">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={economicTags.every((tag) =>
                        checked?.includes(tag)
                      )}
                      onChange={handleEconomicTagsChange}
                      className="checkbox-green"
                      color="success"
                    />
                  }
                  label={<span>Economic Tags</span>}
                />
              </div>
            </div>
          )}

          {/* Show No Result Found if nothing matches */}
          {!showEconomicTags &&
            Array.isArray(filteredDataList) &&
            filteredDataList.length === 0 && (
              <p className="no-result-found-keymdl">No result found</p>
            )}

          {/* Show Filtered Data List */}
          {filteredDataList.length > 0 &&
            filteredDataList.map((item, index) => (
              <div
                key={index}
                className={
                  checked?.includes(item)
                    ? "AI-leade-checkbox-and-data-list_2"
                    : "AI-leade-checkbox-and-data-list"
                }
              >
                <div className="checkbox-select-data">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked?.includes(item)}
                        onChange={(event) => handleCheckboxChange(event, item)}
                        className="checkbox-green"
                        color="success"
                      />
                    }
                    label={
                      <span>
                        {item
                          .split("_")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")}
                      </span>
                    }
                  />
                </div>
              </div>
            ))}
        </div>
      </Select>
    </FormControl>
  );
};

export default KeywordTagsSelect;
